import React, { useMemo, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import SideBar from '../components/sidebar'
import Services from '../components/services'
import { useSelector } from 'react-redux'

import { useGetPricesMutation, useGetProductsMutation, useGetSubscriptionMutation } from '../redux/api/userApi'
import buildServiceList from '../utils/serviceList'
import Loader from '../components/Loader/Loader'
import { filterByProductId } from '../utils/filterByProductId'
import { useGetLeadsMutation } from '../redux/api/ihfApi'
import ServicesAdsMock from '../components/services/adsMock'

const AccountPage: React.FC = () => {
  const userState = useSelector((state: any) => state.userState)
  const { products, prices, subscriptions } = userState
  const [getProducts, { isLoading: isLoadingProducts }] = useGetProductsMutation()
  const [getPrices, { isLoading: isLoadingPrices }] = useGetPricesMutation()
  const [getSubscriptions, { isLoading: isLoadingSubscriptions }] = useGetSubscriptionMutation()
  const [getLeads] = useGetLeadsMutation()

  useEffect(() => {
    getProducts()
      .then(() => {
      }).catch(() => {})
  }, [])

  useEffect(() => {
    getPrices()
      .then(() => {
      }).catch(() => {})
  }, [isLoadingProducts])

  useEffect(() => {
    getSubscriptions()
      .then(() => {
      }).catch(() => {})
  }, [isLoadingPrices])

  useEffect(() => {
    getLeads({ count: 7 })
      .then(() => {})
      .catch(() => {})
  }, [isLoadingSubscriptions])

  const myServices = useMemo(() => {
    return (products || prices || subscriptions) ? filterByProductId(buildServiceList(products, prices, subscriptions), subscriptions) : []
  }, [products, prices, subscriptions])

  const theme = useTheme()

  console.log(subscriptions)
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'column'
        }
      }}
    >
        <SideBar myServices={myServices} />
        <Box
          sx={{
            [theme.breakpoints.down('lg')]: {
              p: '40px 13px',
              width: '100%'
            },
            [theme.breakpoints.up('lg')]: {
              p: '40px',
              width: 'calc(100% - 391px)'
            }
          }}
        >
          <Typography
            sx={{
              color: theme.palette.grey[40],
              mb: '20px',
              [theme.breakpoints.down('lg')]: {
                textAlign: 'center'
              }
            }}
            variant='h3'
          >
            Agent Elite Services
          </Typography>
            {isLoadingPrices && isLoadingProducts
              ? <Loader/>
              : <>
                <Services /><ServicesAdsMock/>
              </>
            }
        </Box>
    </Box>
  )
}

export default AccountPage
